import React, { useState } from "react";
import { getSupabaseClient } from "../services/supabaseClient";
import "../styles/auth.css";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

export default function StaffInvitationsPage() {
    const [email, setEmail] = useState("");
    const [fullName, setFullName] = useState("");
    const [existingEmail, setExistingEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    async function invite(event) {
        event.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        setMessage(null);
        setError(null);
        try {
            const { data, error: sessionError } = await getSupabaseClient().auth.getSession();
            if (sessionError || !data?.session?.access_token) throw new Error("Please sign in again.");
            const response = await fetch(`${API_BASE_URL}/api/staff/invitations`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${data.session.access_token}`,
                },
                body: JSON.stringify({ email: email.trim(), fullName: fullName.trim(), existingEmail: existingEmail.trim() }),
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.error || "Unable to send the invitation.");
            const action = result.outcome === "promoted"
                ? "Existing client account changed to internal staff."
                : result.outcome === "corrected_and_promoted" ? "Existing account email corrected and staff access granted."
                : result.outcome === "resent" ? "Staff setup link resent." : "Staff account invited.";
            setMessage(`${action} Setup email sent to ${result.email}.`);
            setEmail("");
            setFullName("");
            setExistingEmail("");
        } catch (err) {
            setError(err?.message || "Unable to send the invitation.");
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <main className="main-shell">
            <div className="content-shell" style={{ maxWidth: 680 }}>
                <section className="auth-card" aria-labelledby="staff-invite-title">
                    <p className="auth-card-eyebrow">TEAM ACCESS</p>
                    <h1 id="staff-invite-title">Invite internal staff</h1>
                    <p className="auth-description">Send a branded setup email to a Be Accredited colleague. If they already have a client account, their access will be changed to internal staff and they will receive a password setup link.</p>
                    <form className="auth-form" onSubmit={invite}>
                        <label className="form-field"><span>Work email</span>
                            <input type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required placeholder="name@beaccredited.com" disabled={submitting} />
                        </label>
                        <label className="form-field"><span>Name (optional)</span>
                            <input type="text" autoComplete="name" maxLength={120} value={fullName} onChange={(event) => setFullName(event.target.value)} disabled={submitting} />
                        </label>
                        <label className="form-field"><span>Current account email (only if correcting an existing address)</span>
                            <input type="email" autoComplete="off" value={existingEmail} onChange={(event) => setExistingEmail(event.target.value)} placeholder="old-address@example.com" disabled={submitting} />
                        </label>
                        <button className="btn primary" disabled={submitting || !email.trim()}>{submitting ? "Sending…" : "Send staff invitation"}</button>
                    </form>
                    {message && <p role="status">{message}</p>}
                    {error && <p className="error-message" role="alert">{error}</p>}
                </section>
            </div>
        </main>
    );
}
